import React from "react";
import { useTranslation } from "react-i18next";

function Banner() {
  const { t } = useTranslation();

  return (
    <section className="banner-section mt-5">
      <div className="main-container custom-p">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 col-12 text-center text-lg-start mb-5 mb-lg-0">
            <h1 className="fw-bold f-s-48 l-h-60">
              {t("pages.banner.title")}
            </h1>

            <p className="f-s-20 l-h-30 mb-4">{t("pages.banner.text")}</p>

            <div className="contact-box mb-3 d-flex align-items-center">
              <div className="icon-box-phone">
                <img src="/images/icon-phone-call.png" alt="call" width="30" />
              </div>
              <div>
                <h6 className="mb-1 f-s-24 l-h-30 text-start">{t("pages.banner.callUs")}</h6>
                <p className="mb-0 f-s-20 l-h-24">+244 9478 8595 / +244 9478 8595</p>
              </div>
            </div>

            <div className="contact-box mb-3 d-flex align-items-center">
              <div className="icon-box me-3">
                <img src="/images/icon-location.png" alt="location" width="30" height="30" />
              </div>

              <div className="text-start">
                <h6 className="mb-1 f-s-24 l-h-30">{t("pages.banner.location")}</h6>
                <p className="mb-0 f-s-20 l-h-24">{t("common.company.locationLuanda")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
